/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import Loading from 'apps/Loading'

interface IProps {
  loadProgress: number,
}

export const loading = (WrappedComponent: React.ComponentType) => {
  return class LoadingHoc extends React.Component<IProps | any, any> {
    public render () {
      const { loadProgress } = this.props
      return loadProgress !== 100
        ? React.createElement(Loading, { loadProgress })
        : React.createElement(WrappedComponent, this.props)
    }
  }
}
